import React from "react";
import { Navigate } from "react-router-dom";

/** Follow-ups merged into Reminders inbox (same today + overdue queue). */
function FollowUps() {
  return <Navigate to="/reminders" replace />;
}

export default FollowUps;
